import { InputHTMLAttributes, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { IFormFieldProps } from '../../../IFormFieldProps';
import { useAppDispatch, useAppSelector } from '../../../../../store/hook';
import { resetCounter } from '../../../../../store/element/receipt_counter';

interface IProps extends InputHTMLAttributes<HTMLInputElement>, IFormFieldProps {
  classes?: string,
}

const FileCounter = ({ classes, ...rest }: IProps): JSX.Element => {
  const { t } = useTranslation()
    const dispatch = useAppDispatch();
  

  const total: number = useAppSelector(state => state.receiptCounter.count)
  const provided: number = useAppSelector(state => state.receiptCounter.provided)

  const circumference = 119;
  const progress = total > 0 ? Math.min(provided / total, 1) : 0;
  const strokeDashoffset = circumference - (progress * circumference);

  useEffect(() => {
    return () => {
      dispatch(resetCounter());
    };
  }, [dispatch]);

  return (
    <>
      <div className={`doc-card file-counter ${classes}`}>
        <div className='ring-wrap'>
          <svg width="48" height="48" viewBox="0 0 48 48">
            <circle className="ring-track" cx="24" cy="24" r="19"></circle>
            <circle
              stroke="#4B4B4D"
              className="ring-fill"
              cx="24"
              cy="24"
              r="19"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
            />
          </svg>
          <div className='ring-label'>{provided}/{total}</div>
        </div>
        <div>
          <div className='ring-title'>
            {(provided === total && total !== 0) ? t('common.receipt-done') : t('common.receipt-wainting') }
          </div>
          <div className='ring-subtitle'>
            {(provided === total && total !== 0) ? t('common.receipt-done-sub'): t('common.receipt-required-count')}
          </div>
        </div>
      </div>
    </>
  )
}

export default FileCounter;
